// Shared e-mail / domain validation. Every e-mail check in the app should use these
// helpers so the add-recipient, add-coordinator and terms-exception forms agree on
// what a valid address is.

// One DNS label: letters and digits, hyphens allowed inside (e.g. "mpac-group", "1und1").
const DOMAIN_LABEL = "[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?";
// Top-level domain: starts with a letter, at least two characters (also covers
// punycode TLDs such as "xn--p1ai").
const TOP_LEVEL_DOMAIN = "[A-Za-z][A-Za-z0-9-]*[A-Za-z0-9]";
const DOMAIN = `(?:${DOMAIN_LABEL}\\.)+${TOP_LEVEL_DOMAIN}`;
// Local part: the characters browsers accept for <input type="email"> (WHATWG spec).
const LOCAL_PART = "[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+";

const EMAIL_REGEX = new RegExp(`^${LOCAL_PART}@${DOMAIN}$`);
// A domain part as entered for terms exceptions, e.g. "@client.com".
const DOMAIN_PART_REGEX = new RegExp(`^@${DOMAIN}$`);

export const isValidEmail = (email?: string): boolean =>
  EMAIL_REGEX.test((email || "").trim());

export const isValidDomainPart = (domainPart?: string): boolean =>
  DOMAIN_PART_REGEX.test((domainPart || "").trim());

// E-mail addresses are compared case-insensitively, as the backend does when it
// matches an accepting recipient to their invitation.
export const isSameEmail = (a?: string, b?: string): boolean =>
  !!a && !!b && a.trim().toLowerCase() === b.trim().toLowerCase();
